import Image from 'next/image';
import './styles.scss';
import React from 'react';

interface TierCardProps {
    text: string;
    image: string;
    description: string;
    bullets: string[];
    color: string;
    btnLabel: string;
    btnClassName?: string;
    onClick?: () => void;
    disabled?: boolean;
}

const TierCard: React.FC<TierCardProps> = ({
    text,
    image,
    description,
    bullets,
    color,
    btnLabel,
    btnClassName = '',
    onClick = () => {},
    disabled = false,
}) => {
    return (
        <div className="tier-card-container">
            <div style={{ backgroundColor: color }}>
                <Image width={100} height={100} src={image} alt="Tier Image" />
            </div>
            <div className="tier-card-text-and-button">
                <div>
                    <p>{text}</p>
                    <p>{description}</p>
                    <ul>
                        {bullets.map((bullet, idx) => (
                            <li key={idx}>{bullet}</li>
                        ))}
                    </ul>
                </div>
                <div>
                    <button
                        disabled={disabled}
                        className={`btn btn-blue tier-card-btn-${btnClassName} white-space-pre`}
                        onClick={onClick}
                    >
                        {btnLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TierCard;
